

































import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/crm-institution';

@Component({
  components: {
    // Solução para referencia recursiva:
    InstitutionForm: () => import('./institution-form.vue')
  }
})
export default class UiSelectInstitution extends BaseComponent {
  @Prop()
  value: any;

  selected: any = null;
  edit = false;

  loading = false;
  list = [];
  institutionFormOpen = false;

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  mounted() {
    this.load();
  }

  load() {
    this.loading = true;
    service.listInstitutionsCombo().subscribe(
      (res) => {
        this.list = res;
        this.loading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  onFilter(item, queryText, itemText) {
    let it = item.nomeFantasia + item.razaoSocial + item.cnpj.replaceAll(/[^0-9]/g, '');
    let qt = queryText.replaceAll(/[^0-9a-zA-Z]/g, '');
    return this.defaultCustomFilter(item, qt, it);
  }

  onChange() {
    this.$emit('input', this.selected);
    this.$emit('change', this.selected);
  }

  isCanEdit() {
    return (
      !this.$attrs['disabled'] && !this.$attrs['readonly'] &&
      this.selected &&
      (this.$attrs['multiple'] == undefined) &&
      this.hasPermission([this.permissionsKeys.CRM_INSTITUTION_EDIT])
    );
  }

  isCanView() {
    return (
      !this.isCanEdit() &&
      this.selected &&
      (this.$attrs['multiple'] == undefined) &&
      this.hasPermission([this.permissionsKeys.CRM_INSTITUTION_VIEW])
    );
  }  

  onEditItem() {
    this.edit = true;
    this.institutionFormOpen = true;
  }

  onViewItem() {
    this.edit = false;
    this.institutionFormOpen = true;
  }

  onCloseForm() {
    this.institutionFormOpen = false;
  }

  onAfterSave() {
    this.institutionFormOpen = false;
    this.load();
  }
}
